var _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapDestinationPointHover({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M20 39C20 38.4477 20.4477 38 21 38H40C40.5523 38 41 38.4477 41 39C41 39.5523 40.5523 40 40 40H21C20.4477 40 20 39.5523 20 39Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19 39C19 37.8954 19.8954 37 21 37C22.1046 37 23 37.8954 23 39C23 40.1046 22.1046 41 21 41C19.8954 41 19 40.1046 19 39Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 30H20V12H40C41.1046 12 42 12.8954 42 14V28C42 29.1328 41.0841 29.9429 40 30Z",
    fill: "#2F2F32"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 14,
    width: 18,
    height: 14,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12H22V39C22 39.5523 21.5523 40 21 40C20.4477 40 20 39.5523 20 39V12Z",
    fill: "#4D65F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28 26H26V24H28V26Z",
    fill: "#414146"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32 26H30V24H32V26Z",
    fill: "#414146"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36 26H34V24H36V26Z",
    fill: "#414146"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26 24H24V22H26V24Z",
    fill: "#414146"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30 24H28V22H30V24Z",
    fill: "#414146"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M34 24H32V22H34V24Z",
    fill: "#414146"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M38 24H36V22H38V24Z",
    fill: "#414146"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28 22H26V20H28V22Z",
    fill: "#414146"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32 22H30V20H32V22Z",
    fill: "#414146"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36 22H34V20H36V22Z",
    fill: "#414146"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26 20H24V18H26V20Z",
    fill: "#414146"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30 20H28V18H30V20Z",
    fill: "#414146"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34 20H32V18H34V20Z",
    fill: "#414146"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M38 20H36V18H38V20Z",
    fill: "#414146"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28 18H26V16H28V18Z",
    fill: "#414146"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M32 18H30V16H32V18Z",
    fill: "#414146"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M36 18H34V16H36V18Z",
    fill: "#414146"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M20 12H40C41.1046 12 42 12.8954 42 14V28C42 29.1046 41.1046 30 40 30H20V12Z",
    fill: "url(#paint0_linear_2267_164590)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2267_164590",
    x1: 31,
    y1: 12,
    x2: 31,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapDestinationPointHover);
export default __webpack_public_path__ + "static/media/map_destination_point_hover.cf0d7486d9627be54c6c25c86bcc4a1b.svg";
export { ForwardRef as ReactComponent };